var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.layout === "list" && !_vm.isMobile
    ? _c(
        "div",
        { staticClass: "product-list__col col-12 " },
        [
          _c(
            "category-list-item",
            {
              attrs: {
                "item-data-list": _vm.item,
                "decimal-count": _vm.decimalCount,
                "item-list": true
              }
            },
            [[_vm._t("after-prices")], _vm._v(" "), [_vm._t("before-prices")]],
            2
          )
        ],
        1
      )
    : _c(
        "div",
        { staticClass: "product-list__col col-12 col-6 col-md-4" },
        [
          _c(
            "category-item",
            {
              attrs: {
                "item-data-list": _vm.item,
                "decimal-count": _vm.decimalCount,
                "item-list": true
              }
            },
            [[_vm._t("after-prices")], _vm._v(" "), [_vm._t("before-prices")]],
            2
          )
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }